import { SVGProps } from 'react'

export const Favorite = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="currentColor"
      d="M13.75 2.354A4.99 4.99 0 0010 4.096a4.99 4.99 0 00-3.75-1.742c-2.567 0-4.583 2.017-4.583 4.584 0 3.15 2.833 5.716 7.124 9.616L10 17.646l1.208-1.1c4.292-3.892 7.125-6.458 7.125-9.608 0-2.567-2.016-4.584-4.583-4.584zm-3.667 12.959l-.083.083-.084-.084C5.95 11.721 3.333 9.346 3.333 6.938c0-1.667 1.25-2.917 2.917-2.917 1.283 0 2.533.825 2.975 1.967h1.558c.434-1.142 1.684-1.967 2.967-1.967 1.666 0 2.916 1.25 2.916 2.917 0 2.408-2.616 4.783-6.583 8.375z"
    ></path>
  </svg>
)
